import * as moment from "moment-timezone";

export function cancelledTripsReport(trips, fundingSourceName, user) {
  const timeZone = user.timeZone;

  const tableBody: any[][] = [
    [
      { text: "Trip ID", bold: true, fontSize: 9 },
      { text: "Member", bold: true, fontSize: 9 },
      { text: "Driver", bold: true, fontSize: 9 },
      { text: "Scheduled Time", bold: true, fontSize: 9 },
      { text: "Pickup Address", bold: true, fontSize: 9 },
      { text: "Drop Off Address", bold: true, fontSize: 9 },
      { text: "Cancel Reason", bold: true, fontSize: 9 },
    ],
  ];

  trips.forEach((trip) => {
    tableBody.push([
      { text: [trip.refTripId, trip.tripId].filter(Boolean).join(" ") || "", fontSize: 8 },
      { text: (trip.priorityClient && trip.priorityClient.displayName) || "", fontSize: 8 },
      { text: (trip.driver && trip.driver.displayName) || "", fontSize: 8 },
      { text: trip.scheduleTime ? moment(trip.scheduleTime).tz(timeZone).format("MM/DD/YY HH:mm") : "", fontSize: 8 },
      { text: trip.jobOriginAddress || "", fontSize: 8 },
      { text: trip.jobDestinationAddress || "", fontSize: 8 },
      { text: trip.changeReason || "", fontSize: 8 },
    ]);
  });

  return {
    info: {
      title: "Cancelled Trips Report",
      subject: "Cancelled Trips",
    },
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [20, 30, 20, 20],
    content: [
      {
        text: `Cancelled Trips - ${fundingSourceName || ""}`,
        fontSize: 14,
        bold: true,
        margin: [0, 0, 0, 4],
      },
      {
        text: `Generated: ${moment().tz(timeZone).format("MM/DD/YYYY HH:mm")}`,
        fontSize: 9,
        margin: [0, 0, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: ["10%", "15%", "15%", "13%", "20%", "20%", "17%"],
          body: tableBody,
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? "#f3f4f6" : null),
        },
      },
      {
        text: `Total Cancelled Trips: ${trips.length}`,
        fontSize: 9,
        bold: true,
        margin: [0, 10, 0, 0],
      },
    ],
  };
}
